import React from "react";
import "./style.scss";
import FilterIcon from "../../assets/images/debit_report/filter_icon.svg";
import { Form, FormLabel } from "react-bootstrap";
import CommonButton from "../commonButton";
import moment from "moment";
import HideIcon from "../../assets/images/debit_report/hide_icon.svg";
import PlusIcon from "../../assets/images/debit_report/plus_icon.svg";

export default function PayrollFilter({
  filterOptions,
  dateRange,
  selectedOptions,
  handleChange,
  handleDateRangeChange,
  handleTransactionTypeChange,
  handleClearFilter,
  handleFilter,
  showFilter,
  setShowFilter,
  applybtnDisable,
}) {
  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <>
      <div className="payroll-filter-container">
        <div className="payroll-filter-wrapper" onClick={handleShowFilter}>
          {" "}
          <div className="d-flex align-items-center title-filter-wrapper">
            <img src={FilterIcon} alt="filter-icon" />
            <h5>
              Filter options{" "}
              <span>(Expand the filter below to adjust the date range)</span>
            </h5>
          </div>
          <div className="arrow-icon">
            <img src={showFilter ? HideIcon : PlusIcon} alt="hide-show-icon" />
          </div>
        </div>
        {showFilter && (
          <>
            <div className="payroll-sub-filter-wrapper">
              <div className="payroll-input-filter-wrapper">
                <FormLabel htmlFor="startDate">Start Date</FormLabel>
                <Form.Control
                  id="start_date"
                  type="date"
                  value={moment(selectedOptions.start_date).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={handleChange}
                  min={moment().subtract(1, "year").format("YYYY-MM-DD")}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
              <div className="payroll-input-filter-wrapper">
                <FormLabel htmlFor="endDate">End Date</FormLabel>
                <Form.Control
                  id="end_date"
                  type="date"
                  min={moment(selectedOptions.start_date).format("YYYY-MM-DD")}
                  value={moment(selectedOptions.end_date).format("YYYY-MM-DD")}
                  onChange={handleChange}
                  disabled={!selectedOptions.start_date}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>
            <div className="payroll-filter-text">
              <p>
                Preview of pay periods within the selected start and end date
                will be listed below
              </p>
            </div>
            <div className="filter-btn-wrapper">
              <CommonButton
                variant="primary"
                onClick={handleFilter}
                btnText="Apply Filter"
                applybtnDisable={applybtnDisable || !selectedOptions.end_date}
              />
              <CommonButton
                variant="tertiary"
                onClick={handleClearFilter}
                btnText="Clear"
              />
            </div>
          </>
        )}
      </div>{" "}
    </>
  );
}
